import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 no-underline mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-gamepad-line text-lg text-background-50"></i>
              </div>
              <span className="font-heading text-lg text-background-50 whitespace-nowrap">
                撸啊撸攻略大全
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              汇聚撸啊撸英雄选择、出装攻略、对线技巧、团战策略与段位提升全套方案，助你快速从青铜迈向王者。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm text-background-100 mb-4">
              <a href="/category/hero-guide" className="text-background-100 no-underline hover:text-primary-400 transition-colors">攻略分类</a>
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors no-underline"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm text-background-100 mb-4">
              热门文章
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/article/yasuo-complete-guide" className="text-sm text-background-400 hover:text-primary-400 transition-colors no-underline">
                  亚索全方位攻略
                </Link>
              </li>
              <li>
                <Link to="/article/s14-meta-tier-list" className="text-sm text-background-400 hover:text-primary-400 transition-colors no-underline">
                  S14版本强势英雄榜
                </Link>
              </li>
              <li>
                <Link to="/article/mid-lane-laning-guide" className="text-sm text-background-400 hover:text-primary-400 transition-colors no-underline">
                  中单对线终极指南
                </Link>
              </li>
              <li>
                <Link to="/article/bronze-to-gold-climb" className="text-sm text-background-400 hover:text-primary-400 transition-colors no-underline">
                  从青铜到黄金上分法
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm text-background-100 mb-4">
              <Link to="/about" className="text-background-100 no-underline hover:text-primary-400 transition-colors">关于我们</Link>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors no-underline">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="text-sm text-background-400 hover:text-primary-400 transition-colors no-underline">
                  联系我们
                </Link>
              </li>
            </ul>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 撸啊撸攻略大全 版权所有 | 本网站内容仅供学习参考
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors no-underline">隐私政策</a>
              <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors no-underline">用户协议</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}